module.exports = __webpack_public_path__ + "img/spider.1915434a.jpg";